class AppConfig {
    
    encryptionKey = "";
    datadogClientToken = "";
    reactAppOpenSecurityKey = "";
    reactAppSecretKey = "";

    setEncryptionKey(key) {
        this.encryptionKey = key;
    }

    getEncryptionKey() {
        return this.encryptionKey;
    }

    setDatadogClientToken(token) {
        this.datadogClientToken = token;
    }

    getDatadogClientToken() {
        return this.datadogClientToken;
    }

    getReactAppOpenSecurityKey() {
        return this.reactAppOpenSecurityKey;
    }

    setReactAppOpenSecurityKey(key) {
        this.reactAppOpenSecurityKey = key;
    }

    getReactAppSecretKey() {
        return this.reactAppSecretKey;
    }

    setReactAppSecretKey(key) {
        this.reactAppSecretKey = key;
    }

}

export const appConfig = new AppConfig();